import { createTheme } from '@mui/material';

const lightTheme = createTheme({
	palette: {
		mode: 'light',
		primary: {
			main: '#0D285A'
		},
		secondary: {
			main: '#136798'
		},
		info: {
			main: '#aea1bd'
		}
	}
});

const darkTheme = createTheme({
	palette: {
		mode: 'dark',
		primary: {
			main: '#424242'
		},
		secondary: {
			main: '#136798'
		}
	}
});

export const themes = {
	darkTheme,
	lightTheme
};
